import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TEudrInformationResponsePayload,
	TEudrPlansResponsePayload,
	TEudrStatusResponsePayload,
	TEudrStore,
	TEudrUploadedFilesResponsePayload,
} from './types';

const getEudrState = (state: TStoreState): TEudrStore => state.eudr;

export const getEudr = getEudrState;

export const getEudrStatus = createSelector(
	[getEudr],
	(eudr: TEudrStore): TEudrStatusResponsePayload => eudr.status,
);

export const getEudrStatusIsLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.statusLoading,
);

export const getEudrPlans = createSelector(
	[getEudr],
	(eudr: TEudrStore): TEudrPlansResponsePayload => eudr.plans,
);

export const getEudrPlansIsLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.plansLoading,
);

export const getEudrInformation = createSelector(
	[getEudr],
	(eudr: TEudrStore): TEudrInformationResponsePayload => eudr.information,
);

export const getEudrInformationIsLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.informationLoading,
);

export const getUploadedFiles = createSelector(
	[getEudr],
	(eudr: TEudrStore): TEudrUploadedFilesResponsePayload => eudr.uploadedFiles,
);

export const getUploadedFilesIsLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.uploadedFilesLoading,
);

export const getUploadFileIsLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.uploadFileLoading,
);

export const getDownloadFileIsLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.downloadFileLoading,
);
